
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";


const firebaseConfig = {
  apiKey: "AIzaSyC-8tFjLzaQgTwY_xZ5MmGyFAJ5YcRcUMQ",
  authDomain: "freightsee-bba33.firebaseapp.com",
  projectId: "freightsee-bba33",
  storageBucket: "freightsee-bba33.firebasestorage.app",
  messagingSenderId: "694909230818",
  appId: "1:694909230818:web:6c3a502958fbec9d55c8bb",
  measurementId: "G-YM7PBSG3SZ"
};

const app = initializeApp(firebaseConfig);
// Initialize Firebase Cloud Messaging and get a reference to the service
// getMessaging() throws "messaging/unsupported-browser" in browsers without
// the APIs push needs (Incognito, push/service workers disabled, plain http on
// a non-localhost address). Export null there so the app still loads — just
// without push notifications.
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn("Firebase messaging is not supported in this browser:", err?.code || err?.message);
}
export default messaging